import React, { useEffect } from "react";
import Layout from "../../Layout";
import { Button, Input, MenuSelect } from "../../components/Form";
import { FaSave } from "react-icons/fa";
import { AvatarPreview } from "../../components/Uploader";
import Container from "../../components/Container";
import { MdKeyboardArrowDown } from "react-icons/md";
import { currencies } from "../../components/Datas";
import { notations } from "../../components/Datas";
import { useSelector } from "react-redux";

function EditLab() {
	const [image, setImage] = React.useState();
	const [dropdown, setDropdown] = React.useState(false);
	const [dropdown2, setDropdown2] = React.useState(false);
	const [form, setForm] = React.useState();

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleChangeDropdown = (key, e) => {
		setForm({ ...form, [key]: e });
	};

	const handleSubmit = () => {
		// Form submission
	};

	return (
		<Layout>
			<Container>
				<div className="grid col-span-12">
					<div className="flex flex-row items-center justify-center">
						<AvatarPreview image={image} setImage={setImage} />
					</div>
					<Input
						label={"Lab Name *"}
						name={"name"}
						color={true}
						placeholder={"name"}
						type={"text"}
						value={form?.name}
						onChange={handleChange}
					/>
					<Input
						label={"Phone *"}
						name={"phone"}
						color={true}
						placeholder={"name"}
						type={"text"}
						value={form?.phone}
						onChange={handleChange}
					/>
					<Input
						label={"Website"}
						name={"website"}
						color={true}
						placeholder={"name"}
						type={"text"}
						value={form?.website}
						onChange={handleChange}
					/>
					<Input
						label={"Email"}
						name={"email"}
						color={true}
						type={"email"}
						placeholder={"email"}
						value={form?.email}
						onChange={handleChange}
					/>
					<div className="my-2" onClick={() => setDropdown(!dropdown)}>
						<MenuSelect
							datas={currencies}
							onClick={(e) => handleChangeDropdown("currency", e)}
							dbtnClassName={"py-1"}
							isMenuOpen={dropdown}
							setIsMenuOpen={setDropdown}
							staticMode>
							<div className="flex flex-1 flex-col">
								<div className="flex flex-1 w-full">Currency *</div>
								<div className="flex flex-1 justify-between">
									<span>{form?.currency?.title ?? "Select option"}</span>
									<MdKeyboardArrowDown className="text-lg" />
								</div>
							</div>
						</MenuSelect>
					</div>
					<div className="my-2" onClick={() => setDropdown2(!dropdown2)}>
						<MenuSelect
							datas={notations}
							dbtnClassName={"py-1"}
							isMenuOpen={dropdown2}
							setIsMenuOpen={setDropdown2}
							staticMode
							onClick={(e) => handleChangeDropdown("dentalNotation", e.title)}>
							<div className="flex flex-1 flex-col">
								<div className="flex flex-1 w-full">Dental Notation *</div>
								<div className="flex flex-1 justify-between">
									<span>{form?.dentalNotation ?? "Select option"}</span>
									<MdKeyboardArrowDown className="text-lg" />
								</div>
							</div>
						</MenuSelect>
					</div>
					<Input
						label={"Tax Rate(%)"}
						name={"taxrate"}
						color={true}
						placeholder={"Tax Rate(%)"}
						type={"number"}
						value={form?.taxrate}
						onChange={handleChange}
					/>
					<Input
						label={"Address"}
						name={"address"}
						color
						placeholder={"Address"}
						value={form?.address}
						onChange={handleChange}
					/>
					<Button className={"my-2"} label={"Save"} color Icon={FaSave} onClick={handleSubmit} />
				</div>
			</Container>
		</Layout>
	);
}

export default EditLab;
